import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { cn } from '@utils/cn';

export const tableLegendClassNames = {
  root: 'Chart-TableLegend',
} as const;

export type TableLegendRootProps = BoxProps<'ul'>;

export const TableLegendRoot = ({ children, sx, className, ...props }: TableLegendRootProps) => (
  <Box
    component="ul"
    aria-label="Chart legend"
    className={cn(
      tableLegendClassNames.root,
      'm-0 grid h-full w-full grid-cols-[1fr_max-content_max-content] gap-x-[18px] gap-y-0 overflow-auto p-0 [align-content:safe_center]',
      className
    )}
    sx={sx}
    {...props}>
    {children}
  </Box>
);
